import React from "react";

// * Styles
import {
  ContainerFluid,
  Card,
  ImgWrapper,
  Img,
  TextWrapper,
  Heading,
  InfoRow,
  InfoColumn,
  TextSpan,
  InfoLabel,
  Container,
} from "./Book.elements";

const Book = ({ items }) => {
  return (
    <ContainerFluid>
      <Container>
        {items.map((item) => {
          return (
            <Card>
              <InfoRow>
                <InfoColumn>
                  <ImgWrapper>
                    <Img src={item.img}></Img>
                  </ImgWrapper>
                </InfoColumn>
                <InfoColumn>
                  <TextWrapper>
                    <Heading>{item.title}</Heading>
                    <InfoLabel>
                      <TextSpan>نویسنده : </TextSpan>
                      {item.author}
                    </InfoLabel>
                    <InfoLabel>
                      <TextSpan>ژانر : </TextSpan>
                      {item.category}
                    </InfoLabel>
                    <InfoLabel>
                      <TextSpan>جلد : </TextSpan>
                      {item.cover}
                    </InfoLabel>
                    <InfoLabel>
                      <TextSpan> {item.pages} صفحه </TextSpan>
                    </InfoLabel>
                  </TextWrapper>
                </InfoColumn>
              </InfoRow>
            </Card>
          );
        })}
      </Container>
    </ContainerFluid>
  );
};

export default Book;
